import React from 'react'
import CalenderEventForm from './CalenderEventForm'
import moment from 'moment'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  Chip
} from '@mui/material';
import { useAppData } from '../../../../../context/AppDataContext';
import EventArchive from './EventArchive';


function CalendarDetailsModal() {
  const {getCalendarEventList} = useAppData();
  const {selectedEvent, setSelectedEvent} = useAppData();

  const callBack = () =>{
    getCalendarEventList();
    setSelectedEvent(false);
  }

  
  
  return (
    selectedEvent &&
        <Dialog open={true} onClose={() => setSelectedEvent(false) } fullWidth maxWidth="sm">
            <DialogTitle>
              {selectedEvent.title} 
              <span className='float-end'> <CalenderEventForm data={selectedEvent} callBack={callBack} /></span>
              <span className='float-end me-2'><EventArchive event={selectedEvent} /></span>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Typography variant="body1" gutterBottom>
                {selectedEvent.details}
              </Typography>
              <Typography variant="caption" display="block">
                Time: {`${moment(selectedEvent.startDate).format("LL")} ${moment(selectedEvent.startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(selectedEvent.endDate).format("LL")} ${moment(selectedEvent.endTime, "HH:mm:ss").format("hh:mm A")}  `}
              </Typography>
              <hr/>
              <Typography variant="body1" gutterBottom>
                {selectedEvent.to}
              </Typography>  
            </DialogContent>
            <DialogActions>
              
              <button className='btn btn-outline-primary' onClick={() => setSelectedEvent(false)}>Close</button>
            </DialogActions>
        </Dialog>
    )
}

export default CalendarDetailsModal